(function () {
  'use strict';

  angular
    .module('app.exposureReportPlatform')
    .factory('exposureReportPlatformService', ['$q', '$http', '$rootScope', 'measureService',
      function ($q, $http, $rootScope, measureService) {
        var service = {};

        function checkResponse(data) {
          return data;
        }

        function getMessage(data) {
          if (data) {
            return data.message;
          }
          return false;
        }

        function handleRequest(url) {
          var deferred = $q.defer(), result = 'requestFail';
          $http.get(url)
            .success(function (data) {
              var dataRes = angular.fromJson(data);

              if (checkResponse(dataRes)) {
                deferred.resolve(dataRes);
              } else {
                deferred.reject(getMessage(dataRes) || result);
              }
            })
            .error(function () {
              deferred.reject(result);
            });

          return deferred.promise;
        }

        function getExposurePlatform(params) {
          var url_getExposurePlatform = $rootScope.apiUrl + 'measure/getExposurePlatforms?' + $.param(params);
          return handleRequest(url_getExposurePlatform);
        }

        service.getExposurePlatform = getExposurePlatform;

        return service;
      }]);
})();